/*** IMPORTS FROM imports-loader ***/
var define = false;

import { debounce } from 'underscore'

const loadMobileMenu = () => {
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle')

    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', () => {
            document.body.classList.toggle('mobile-menu-visible')
        })
    }

    window.addEventListener('resize', debounce(() => {
        const windowWidth = window.innerWidth

        if (windowWidth >= 960) {
            document.body.classList.remove('mobile-menu-visible')
        }
    }, 100))
}

export default loadMobileMenu




// WEBPACK FOOTER //
// ./js/mobileMenu.js